import React, { useState, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Badge, FormGroup, Label } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import { useUpdateProjectMutation } from "store/features/client/clientManagementApi";
import { useGetAllDesignersQuery, useGetAllDevelopersQuery, useGetAllProjectManagersQuery } from "store/features/developer/developerManagementApi";
import Select from "react-select";
import { toast } from "sonner";
import { useSelector } from "react-redux";
import { selectUser } from "store/features/auth/authSlice";

const EditProjectModal = ({ isOpen, toggle, project, client, onProjectUpdate }) => {
  const user = useSelector(selectUser);

  const [updateProject, { isLoading }] = useUpdateProjectMutation();
  const { data: developers = [] } = useGetAllDevelopersQuery();
  const { data: designers = [] } = useGetAllDesignersQuery();
  const { data: projectManagers = [] } = useGetAllProjectManagersQuery();

  const [newWorkLog, setNewWorkLog] = useState('');

  console.log("developers", developers);
  console.log("projectManagers", projectManagers);
  console.log("designers", designers);

  const [selectedTeam, setSelectedTeam] = useState(
    project?.assigned_team?.map(id => {
      const dev = developers.find(d => d.id === id);
      return dev ? { value: dev.id, label: `${dev.nickname} (${dev.role})` } : null;
    }).filter(Boolean) || []
  );


  const [selectedProjectManager, setSelectedProjectManager] = useState(
    project?.assigned_project_manager?.map(id => {
      console.log("idid", id);

      const dev = projectManagers.find(d => d.id === id);

      return dev ? { value: dev.id, label: `${dev.nickname} (${dev.role})` } : null;
    }).filter(Boolean) || []
  );


  console.log("selectedProjectManager selectedProjectManager", selectedProjectManager);

  const [selectedFrontendDev, setSelectedFrontendDev] = useState(
    project?.assigned_frontend_dev?.map(id => {
      const dev = developers.find(d => d.id === id);
      return dev ? { value: dev.id, label: `${dev.nickname} (${dev.role})` } : null;
    }).filter(Boolean) || []
  );

  const [selectedBackendDev, setSelectedBackendDev] = useState(
    project?.assigned_backend_dev?.map(id => {
      const dev = developers.find(d => d.id === id);
      return dev ? { value: dev.id, label: `${dev.nickname} (${dev.role})` } : null;
    }).filter(Boolean) || []
  );

  const [selectedDesigner, setSelectedDesigner] = useState(
    project?.assigned_designer?.map(id => {
      const dev = designers.find(d => d.id === id);
      return dev ? { value: dev.id, label: `${dev.nickname} (${dev.role})` } : null;
    }).filter(Boolean) || []
  );

  console.log("selectedDesignerselectedDesigner", selectedDesigner);



  const [projectProposal, setProjectProposal] = useState(null);
  const [contract, setContract] = useState(null);
  const [invoice1, setInvoice1] = useState(null);
  const [invoice2, setInvoice2] = useState(null);

  const developerOptions = useMemo(() => {
    return developers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [developers]);

  const projectManagersOptions = useMemo(() => {
    return projectManagers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [projectManagers]);

  const FrontendDeveloperOptions = useMemo(() => {
    return developers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [developers]);

  const BackendDeveloperOptions = useMemo(() => {
    return developers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [developers]);

  const designerOptions = useMemo(() => {
    return designers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [designers]);



  const handleSubmit = async (data) => {
    try {

      console.log("data.payment", data.payment);

      // Fix payment data logic - better validation
      let paymentData = project?.payment || [];

      // Check if payment field has a valid numeric value
      const paymentAmount = parseFloat(data.payment);
      if (!isNaN(paymentAmount) && paymentAmount > 0) {
        // Only create new payment entry if payment value is valid and positive
        paymentData = [
          ...(project?.payment || []),
          {
            id: (project?.payment?.length || 0) + 1,
            amount: paymentAmount,
            date: new Date().toISOString().split('T')[0],
          },
        ];
      }

      // Handle work logs - use the separate newWorkLog state
      let workLogs = project?.work_logs || [];

      if (newWorkLog && newWorkLog.trim() !== "") {
        workLogs = [
          ...workLogs,
          {
            id: (workLogs.length || 0) + 1,
            user_id: user?.id || "",
            user_name: user?.nickname || "",
            user_role: user?.role || "",
            log: newWorkLog.trim(),
            date: new Date().toISOString().split('T')[0],
          },
        ];
        // Clear the new work log after adding
        setNewWorkLog('');
      }


      // const paymentData = data.payment
      //   ? project?.payment
      //     ? [
      //       ...(project?.payment || []),
      //       {
      //         id: (project?.payment?.length || 0) + 1,
      //         amount: data.payment,
      //         date: new Date().toISOString().split('T')[0],
      //       },
      //     ]
      //     : [
      //       {
      //         id: 1,
      //         amount: data.payment,
      //         date: new Date().toISOString().split('T')[0],
      //       },
      //     ]
      //   : project?.payment || [];


      // const workLogs = data.work_logs
      //   ? project?.work_logs
      //     ? [
      //       ...(project?.work_logs || []),
      //       {
      //         id: (project?.work_logs?.length || 0) + 1,
      //         user_id: user?.id || "",
      //         user_name: user?.nickname || "",
      //         user_role: user?.role || "",
      //         log: data.work_logs,
      //         date: new Date().toISOString().split('T')[0],
      //       },
      //     ]
      //     : [
      //       {
      //         id: 1,
      //         user_id: user?.id || "",
      //         user_name: user?.nickname || "",
      //         user_role: user?.role || "",
      //         log: data.work_logs,
      //         date: new Date().toISOString().split('T')[0],
      //       },
      //     ]
      //   : project?.work_logs || [];


      console.log("workLogs", workLogs);
      console.log("paymentData", paymentData);

      const formData = new FormData();

      // Append regular form data
      formData.append('name', data.name);
      formData.append('description', data.description || '');
      formData.append('client', project.client);
      formData.append('budget', data.budget || '0.00');

      // formData.append("payment", JSON.stringify(paymentData));
      // formData.append("work_logs", JSON.stringify(workLogs));

      // Only append payment if there are actual payments
      if (paymentData.length > 0) {
        formData.append("payment", JSON.stringify(paymentData));
      } else {
        // If no payments, explicitly set empty array
        formData.append("payment", JSON.stringify([]));
      }

      // Always append work_logs (could be empty array)
      formData.append("work_logs", JSON.stringify(workLogs));

      // formData.append('start_date', data.start_date || '');
      // formData.append('end_date', data.end_date || '');
      if (data.start_date !== project?.start_date) formData.append('start_date', data.start_date || '');
      if (data.end_date !== project?.end_date) formData.append('end_date', data.end_date || '');

      formData.append('status', data.status || 'Pending');
      formData.append('priority_status', data.priority_status || '3');
      formData.append('progress', data.progress || '0');

      // Append assigned team
      // selectedTeam.forEach(dev => {
      //   formData.append('assigned_team', dev.value);
      // });

      selectedProjectManager.forEach(dev => {
        formData.append('assigned_project_manager', dev.value);
      });

      selectedFrontendDev.forEach(dev => {
        formData.append('assigned_frontend_dev', dev.value);
      });

      selectedBackendDev.forEach(dev => {
        formData.append('assigned_backend_dev', dev.value);
      });

      selectedDesigner.forEach(dev => {
        formData.append('assigned_designer', dev.value);
      });


      // Compare team IDs first
      // const currentTeamIds = project?.assigned_team || [];
      // const newTeamIds = selectedTeam.map(dev => dev.value);

      // if (JSON.stringify(currentTeamIds.sort()) !== JSON.stringify(newTeamIds.sort())) {
      //   newTeamIds.forEach(devId => {
      //     formData.append('assigned_team', devId);
      //   });
      // }



      // Append files if they exist
      if (projectProposal) {
        formData.append('project_proposal', projectProposal);
      }
      if (contract) {
        formData.append('contract', contract);
      }
      if (invoice1) {
        formData.append('invoice_1', invoice1);
      }
      if (invoice2) {
        formData.append('invoice_2', invoice2);
      }

      await updateProject({ id: project.id, formData }).unwrap();
      toast.success("Project updated successfully");
      onProjectUpdate();
    } catch (error) {
      toast.error("Failed to update project");
      console.error('Project update error:', error);
    }
  };

  const handleTeamChange = (selectedOptions) => {
    setSelectedTeam(selectedOptions || []);
  };

  const handleProjectManagerChange = (selectedOptions) => {
    setSelectedProjectManager(selectedOptions || []);
  };

  const handleFrontendDevChange = (selectedOptions) => {
    setSelectedFrontendDev(selectedOptions || []);
  };

  const handleBackendDevChange = (selectedOptions) => {
    setSelectedBackendDev(selectedOptions || []);
  };

  const handleDesignerChange = (selectedOptions) => {
    setSelectedDesigner(selectedOptions || []);
  };

  const removeTeamMember = (developerId) => {
    setSelectedTeam(prev => prev.filter(dev => dev.value !== developerId));
  };

  const handleFileChange = (setter, event) => {
    const file = event.target.files[0];
    setter(file);
  };

  const handleModalClose = () => {
    // Reset file states when modal closes
    setProjectProposal(null);
    setContract(null);
    setInvoice1(null);
    setInvoice2(null);
    setNewWorkLog('');
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleModalClose} size="lg">
      <ModalHeader toggle={handleModalClose}>Edit Project - {project?.name}</ModalHeader>
      <QwikForm onSubmit={handleSubmit} defaultValues={project}>
        <ModalBody>
          <Row>
            {(user?.role == "super_admin" || user?.role == "admin") ? (
              <>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="name"
                      label="Project Name"
                      placeholder="Enter project name"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="budget"
                      label="Budget"
                      placeholder="Enter budget"
                      type="number"
                      step="0.01"
                      className="form-control"
                    />
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="mb-3">
                    <QwikInput
                      name="description"
                      label="Description"
                      placeholder="Enter project description"
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="start_date"
                      label="Start Date"
                      type="date"
                      className="form-control"
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="end_date"
                      label="End Date"
                      type="date"
                      className="form-control"
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="progress"
                      label="Progress (%)"
                      type="number"
                      min="0"
                      max="100"
                      className="form-control"
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="payment"
                      label="Payment"
                      placeholder="Enter payment"
                      type="number"
                      step="0.01"
                      className="form-control"
                    />
                  </div>
                </Col>

                {/* {project?.work_logs && project.work_logs.length > 0 && (
              <Col lg={12}>
                <div className="mb-3">
                  <label className="form-label">Existing Work Logs</label>
                  <div className="border rounded p-3 bg-light">
                    {project.work_logs.map((log, index) => (
                      <div key={log.id || index} className="mb-2 pb-2 border-bottom">
                        <div className="d-flex justify-content-between">
                          <strong>{log.user_name} ({log.user_role})</strong>
                          <small className="text-muted">{log.date}</small>
                        </div>
                        <div className="mt-1">{log.log}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            )} */}

                {/* Input for new work log */}
                {/* <Col lg={12}>
                  <div className="mb-3">
                    <label className="form-label">Add New Work Log</label>
                    <textarea
                      value={newWorkLog}
                      onChange={(e) => setNewWorkLog(e.target.value)}
                      placeholder="Enter new work log"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col> */}


                {/* <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="work_logs"
                  label="Work Log"
                  placeholder="Enter work log"
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col> */}





                <Col lg={6}>
                  <div className="mb-3">
                    <QwikSelect
                      name="status"
                      label="Status"
                      options={[
                        { value: "Pending", label: "Pending" },
                        { value: "In Progress", label: "In Progress" },
                        { value: "Completed", label: "Completed" },
                        { value: "On Hold", label: "On Hold" }
                      ]}
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikSelect
                      name="priority_status"
                      label="Priority status"
                      options={[
                        { value: "1", label: "High" },
                        { value: "2", label: "Medium" },
                        { value: "3", label: "Low" },
                      ]}
                    />
                  </div>
                </Col>


                {/* File Upload Fields */}
                <Col lg={6}>
                  <FormGroup>
                    <Label for="project_proposal" className="form-label">
                      Project Proposal
                    </Label>
                    {project?.project_proposal && (
                      <div className="mb-2">
                        <a
                          href={project.project_proposal}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary btn-sm"
                        >
                          <i className="fas fa-eye me-1"></i> View Current
                        </a>
                      </div>
                    )}
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="project_proposal"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileChange(setProjectProposal, e)}
                      />
                    </div>
                  </FormGroup>
                </Col>

                <Col lg={6}>
                  <FormGroup>
                    <Label for="contract" className="form-label">
                      Contract
                    </Label>
                    {project?.contract && (
                      <div className="mb-2">
                        <a
                          href={project.contract}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary btn-sm"
                        >
                          <i className="fas fa-eye me-1"></i> View Current
                        </a>
                      </div>
                    )}
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="contract"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileChange(setContract, e)}
                      />
                    </div>
                  </FormGroup>
                </Col>

                <Col lg={6}>
                  <FormGroup>
                    <Label for="invoice_1" className="form-label">
                      Invoice 1
                    </Label>
                    {project?.invoice_1 && (
                      <div className="mb-2">
                        <a
                          href={project.invoice_1}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary btn-sm"
                        >
                          <i className="fas fa-eye me-1"></i> View Current
                        </a>
                      </div>
                    )}
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="invoice_1"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileChange(setInvoice1, e)}
                      />
                    </div>
                  </FormGroup>
                </Col>

                <Col lg={6}>
                  <FormGroup>
                    <Label for="invoice_2" className="form-label">
                      Invoice 2
                    </Label>
                    {project?.invoice_2 && (
                      <div className="mb-2">
                        <a
                          href={project.invoice_2}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary btn-sm"
                        >
                          <i className="fas fa-eye me-1"></i> View Current
                        </a>
                      </div>
                    )}
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="invoice_2"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileChange(setInvoice2, e)}
                      />
                    </div>
                  </FormGroup>
                </Col>

                {/* <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Assign Team</label>
                <Select
                  options={developerOptions}
                  isMulti
                  value={selectedTeam}
                  onChange={handleTeamChange}
                  placeholder="Search developers by name or email..."
                  classNamePrefix="select2-selection"
                />
              </div>

              {selectedTeam.length > 0 && (
                <div className="mb-3">
                  <label className="form-label">Selected Team Members:</label>
                  <div className="d-flex flex-wrap gap-2">
                    {selectedTeam.map(dev => (
                      <Badge key={dev.value} color="primary" className="p-2 d-flex align-items-center">
                        {dev.label}
                        <button
                          type="button"
                          className="btn-close btn-close-white ms-2"
                          style={{ fontSize: '10px' }}
                          onClick={() => removeTeamMember(dev.value)}
                        />
                      </Badge>
                    ))}
                  </div>
                </div>
              )}
            </Col> */}

                <Col lg={12}>
                  <div className="mb-3">
                    <label className="form-label">Assign Project Manager</label>
                    <Select
                      options={projectManagersOptions}
                      isMulti
                      value={selectedProjectManager}
                      onChange={handleProjectManagerChange}
                      placeholder="Search project Manager by name or email..."
                      classNamePrefix="select2-selection"
                    />
                  </div>


                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <label className="form-label">Assign Frontend Developers</label>
                    <Select
                      options={FrontendDeveloperOptions}
                      isMulti
                      value={selectedFrontendDev}
                      onChange={handleFrontendDevChange}
                      placeholder="Search frontend developers by name or email..."
                      classNamePrefix="select2-selection"
                    />
                  </div>


                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <label className="form-label">Assign Backend Developers</label>
                    <Select
                      options={BackendDeveloperOptions}
                      isMulti
                      value={selectedBackendDev}
                      onChange={handleBackendDevChange}
                      placeholder="Search backend developers by name or email..."
                      classNamePrefix="select2-selection"
                    />
                  </div>


                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <label className="form-label">Assign Designers</label>
                    <Select
                      options={designerOptions}
                      isMulti
                      value={selectedDesigner}
                      onChange={handleDesignerChange}
                      placeholder="Search designer by name or email..."
                      classNamePrefix="select2-selection"
                    />
                  </div>


                </Col>
              </>
            ) : (

              <Col lg={12}>
                {/* <div className="mb-3">
                  <label className="form-label">Add New Work Log</label>
                  <textarea
                    value={newWorkLog}
                    onChange={(e) => setNewWorkLog(e.target.value)}
                    placeholder="Enter new work log"
                    className="form-control"
                    rows="5"
                  />
                </div> */}
              </Col>
            )
            }

          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Project"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default EditProjectModal;